import { render, staticRenderFns } from "./PublicSocialLoginInstagram.vue?vue&type=template&id=8314cd86"
import script from "./PublicSocialLoginInstagram.vue?vue&type=script&lang=ts"
export * from "./PublicSocialLoginInstagram.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports